import { getInFilterValue } from '../utils';
import { BaseHelper } from './BaseGraphQLAPIHelper';


const STORE_NODE = `
id
pk
name
isOnlineStore
visibleInFrontEnd
active
thirdPartySyncTime
displayPriority
photo
photoUrl
address
phoneNumberCountryCode
phoneNumberSubscriberNumber
codeDisplayImage
codeDownloadImage
latitude
longitude
emailAddress
description
staffCode
couponStock
subcategories(first: 50) {
  edges {
    node {
      pk
      category {
        name
        displayPriority
      }
      name
      displayPriority
    }
  }
}
district {
  region {
      pk
      name
  }
  name
}
brand {
  pk
  name
}
mall {
  pk
  name
}
translations {
  edges {
    node {
      language
      name
      description
      address
    }
  }
}
`;

const SIMPLE_STORE_NODE = `
id
pk
name
isOnlineStore
visibleInFrontEnd
translations {
  edges {
    node {
      language
      name
    }
  }
}
`;

const LIST_NODE = `
id
pk
name
photo
photoUrl
displayPriority
brand {
  pk
  name
}
phoneNumberCountryCode
phoneNumberSubscriberNumber
emailAddress
isOnlineStore
visibleInFrontEnd
active
subcategories(first: 50) {
  edges {
    node {
      pk
      name
      displayPriority
    }
  }
}
lastModifiedDate
`;

export const getPureStores = () => {
  const query = `{
    pureStores {
      pk
      name
      visibleInFrontEnd
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getPagedStores = (afterCursor, search = {}) => {
  // const order = rank ? '-pk' : 'pk';
  console.log('@@73: ', search);
  let searchString = '';
  if (search.search) {
    if (search.searchField) {
      searchString += `, ${search.searchField}: "${search.search}"`;
    } else {
      searchString += `, name: "${search.search}"`;
    }
  }
  if (search.idIn) {
    searchString += `, idIn: ${getInFilterValue(
      search.idIn,
    )}`;
  }
  if (search.subcategory) {
    searchString += `, subcategoriesIn: ${getInFilterValue(
      search.subcategory,
    )}`;
  }
  if (search.brand) {
    searchString += `, brandIn: ${getInFilterValue(search.brand)}`;
  }
  if (search?.isOnlineStore || search?.store_type === 'online') {
    searchString += ', isOnlineStore: true';
  } else if (
    (search?.isOnlineStore !== undefined && !search?.isOnlineStore) ||
    search?.store_type === 'offline'
  ) {
    searchString += ', isOnlineStore: false';
  }

  if (search?.visible_in_front_end !== undefined) {
    searchString += `, visibleInFrontEnd: ${search.visible_in_front_end}`;
  }

  if (search?.couponTemplate) {
    searchString += `, couponTemplate: ${search.couponTemplate}`;
  }

  if (search?.active) {
    searchString += `, active: ${search.active}`;
  }

  let orderBy = 'displayPriority';
  if (search?.sort) {
    orderBy = search.sort;
  }
  let pageSize = 20;
  if (search?.pageSize) {
    pageSize = search.pageSize;
  }
  const storeNode = search?.isListNode
    ? LIST_NODE
    : search?.isSimpleNode
    ? SIMPLE_STORE_NODE
    : STORE_NODE;
  const query = `{
    stores(first: ${pageSize}, after: "${afterCursor}", orderBy: "${orderBy}"${searchString}) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ${storeNode}
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getPagedSimplyStoresWithBrand = (
  afterCursor,
  sort = 'brand',
  pageSize = 20,
) => {
  const query = `{
    stores(first:${pageSize}, after: "${afterCursor}", orderBy: "${sort}") {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          name
          address
          brand {
            pk
            name
          }
          visibleInFrontEnd
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getOneStore = (id) => {
  const query = `query StoreDetail {
    store(id: "${id}") {
      id
      pk
      name
      displayPriority
      photo
      photoUrl
      address
      phoneNumberCountryCode
      phoneNumberSubscriberNumber
      codeDisplayImage
      codeDownloadImage
      latitude
      longitude
      emailAddress
      description
      staffCode
      isOnlineStore
      visibleInFrontEnd
      active
      thirdPartySyncTime
      thirdPartyStoreCode
      creationDate
      lastModifiedDate
      lastModifiedBy
      lastModifiedByAdmin {
        id
        pk
        username
      }
      subcategories(first: 50) {
          edges {
              node {
                  pk
                  id
                  category {
                      name
                      displayPriority
                  }
                  name
                  displayPriority
              }
          }
      }
      district {
          region {
              pk
              name
          }
          name
          pk
      }
      brand {
          pk
          name
      }
      mall {
          pk
          name
      }
      translations {
          edges {
          node {
              pk
              language
              name
              description
              address
          }
          }
      }
    }
  }
  `;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const deleteStores = (ids) => {
  const query = `mutation DeleteStores($input: DeleteStoresInput!) {
    deleteStores(input: $input) {
      success
    }
  }
  `;
  const variables = { input: { ids: ids } };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const createOrUpdateStore = (values) => {
  const action = values.id ? 'Update' : 'Create';
  let query = `mutation ${action}Store($input: ${action}StoreInput!) {
    ${action.toLowerCase()}Store(input: $input) {
      success
      node {
          id
          pk
          name
          displayPriority
          photo
          photoUrl
          address
          phoneNumberCountryCode
          phoneNumberSubscriberNumber
          latitude
          longitude
          emailAddress
          description
          staffCode
          isOnlineStore
          visibleInFrontEnd
          active
          thirdPartySyncTime
          subcategories {
              edges {
                  node {
                      pk
                      category {
                          name
                          displayPriority
                      }
                      name
                      displayPriority
                  }
              }
          }
          district {
              region {
                  pk
                  name
              }
              name
          }
          brand {
              pk
          }
          mall {
            pk
            name
          }
          translations {
            edges {
              node {
                pk
                language
                name
                description
                address
              }
            }
          }
      }
      errors {
        field
        messages
      }
    }
  }

  `;

  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getDistricts = (afterCursor, search) => {
  let filter = '';

  if (search?.search) {
    filter += `, nameIcontains: "${search.search}"`;
  }
  const query = `{
    districts(first: 50, after: "${afterCursor}", orderBy: "pk"${filter}) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          pk
          region {
              pk
              name
          }
          name
          translations {
            edges {
              node {
                language
                name
                pk
              }
            }
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getDownloadStoreCodesZip = (values) => {
  const query = `mutation DownloadStores($input: DownloadStoreCodesInput!) {
    downloadStores(input: $input) {
      success
      zipLink
    }
  }`;
  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getAllCouponStores = (values) => {
  console.log('491: ', values);
  let query = `mutation FilterStores($input: FilterStoresInput!) {
    filterStores(input: $input) {
      stores {
        id
        name
        isOnlineStore
        brandId
        mallId
        storeCategoryIds
        ${
          values.needStock
            ? `
          stock
          address
        `
            : ''
        }
        visibleInFrontEnd
      }
      brands {
        id
        name
      }
      malls {
        id
        name
      }
      storeCategories {
        id
        name
      }
    }
}`;
  if (values?.searchField && values?.searchKey) {
    values[values?.searchField] = values?.searchKey;
    delete values?.searchField;
    delete values?.searchKey;
  }
  const variables = { input: values };
  return BaseHelper.callGraphQLAPI({ query, variables });
};